import { render, staticRenderFns } from "./addFamily.vue?vue&type=template&id=75aae93d&scoped=true&"
import script from "./addFamily.vue?vue&type=script&lang=js&"
export * from "./addFamily.vue?vue&type=script&lang=js&"
import style0 from "./addFamily.vue?vue&type=style&index=0&id=75aae93d&prod&lang=less&scoped=true&"
import style1 from "./addFamily.vue?vue&type=style&index=1&id=75aae93d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aae93d",
  null
  
)

export default component.exports